/*
BEST PRACTICE: define enums
export enum UserRole {
    Guest = "guest",
    User = "user",
    Admin = "admin"
}
// convert to array for Zod schema
export const USER_ROLES = Object.values(UserRole) as readonly UserRole[];

export const zUserRole = z.enum(USER_ROLES);
*/

export enum UserRole {
    Guest = "guest",
    User = "user",
    Manager = "manager",
    Admin = "admin",
    Dev = "dev",
}
// Default role
export const USER_DEFAULT_ROLE = UserRole.Guest;
// Available roles as an array (for Mongoose schema)
export const USER_ROLES = Object.values(UserRole) as readonly UserRole[];

export enum UserType {
    Provider = "provider",
    Announcer = "announcer",
    Fan = "fan",
    Admin = "admin",
}

export const USER_DEFAULT_TYPE = UserType.Fan;
export const USER_TYPES: string[] = Object.values(UserType);


export interface UserFileEntry {
    key: string;
    size: number;
    lastModified: Date;
    uri: string;
}

export enum UserFileFolder {
    Profile = "profile",
    Audio = "audio",
    Event = "event",
    Contract = "contract",
}
export const USER_FILE_FOLDERS: string[] = Object.values(UserFileFolder);




